import React, { useState, useEffect } from 'react';
import ProfileHeader from '../components/layout/header/ProfileHeader';
import Footer from '../components/layout/Footer';
import EventTable from '../components/EventTable';
import axios from 'axios';
const MyEvent = () => {
  return (
    <div className='pt-5'>
      <ProfileHeader />
      <div className='container-md-fluid py-5 my-5'>
        <div className='ps-4'>
          <h4 className='ps-md-5 ms-1' style={{ fontWeight: 'bold' }}>
            History
          </h4>
        </div>
        <EventTable />
        {/* {history.map((his) => (
          <EventTable key={his._id} history={his} />
        ))} */}
      </div>
      <Footer />
    </div>
  );
};

export default MyEvent;
